import {PeriodTypeValues} from '@web/core/constants'

export const ProcessStatus = {
    /** 프로세스 시작 전 */
    IDLE: 'IDLE',
    /** 프로세스 중 */
    PENDING: 'PENDING',
    /** apply 준비가 안된 신청건 */
    NOT_READY: 'NOT_READY',
    /** apply 준비가 된 신청건 */
    READY: 'READY',
    /** 신청 성공 */
    SUCCESS: 'SUCCESS',
    /** 신청 실패 */
    FAIL: 'FAIL',
    /** 신청 성공/실패 여부 알 수 없음 */
    UNKNOWN: 'UNKNOWN',
} as const

export type ProcessStatusValues = Constant<typeof ProcessStatus>

export interface ShoppingSubscriptionState {
    /** 정기구독 신청 번호 */
    reservedId: Maybe<string>
    /** 정기구독 신청 진행 상태 */
    processStatus: ProcessStatusValues
    /** 1회차 도착예정일 */
    firstDeliveryDate: string
    /** 1회차 결제일 */
    firstPaymentDate: string
    /** 구독 주기 */
    periodType: PeriodTypeValues
    /** 구독 회차  (무제한 구독인 경우 -1) */
    periodCount: number
    /** 자동결제수단 번호 */
    paymentMethodSeqNo: Maybe<number>
    /** 유저가 선택가능한 최대 정기구독 회차 수 */
    selectableMaxPeriodCount: Maybe<number>
    /** 즉시결제 여부 */
    isImmediatePayment: boolean
    /** 즉시결제 성공 여부 */
    isImmediatePaymentSuccess: boolean
}

export type RootState = {shoppingSubscription: ShoppingSubscriptionState}
